module.exports = __webpack_public_path__ + "static/media/registered.1119380d.svg";